import { Record } from 'immutable';
class ExternalProperty extends Record({
  id: 0,
  name: ''
}) {}
ExternalProperty.fromJS = obj => new ExternalProperty(Object.assign({}, obj));
export default ExternalProperty;